import { ITEMS_PER_PAGE, Language } from '../helpers/Constants';
import Routes from '../helpers/Routes';
import { encryptPassword } from '../helpers/utils';
import {
  GenericPaginationModelAPIParams,
  IGetPublicRatingItems,
  IPharmacyRatesProfessional,
  IRatePharmacyParams,
  ISmartRegisterParams,
} from '../models';
import { ISystemDetailParams } from '../models/UtilModel';
import httpClient from './httpClient';

const { anonymous } = Routes.general;

class UtilController {
  constructor() {}
  getContactInfo = async () => httpClient.get(`${Routes.util.getContactInfo}`);
  getLanguagesInfo = async () =>
    httpClient.get(
      `${Routes.authentication.authBasePath}${Routes.general.languages}`
    );
  getPublicKey = async (deviceId: string) =>
    httpClient.get(
      `${Routes.general.system}/${Routes.util.getPublicKey}/${deviceId}`
    );

  registerSmartLogin = async (params: ISmartRegisterParams) => {
    const encryptedTotp = encryptPassword(params.totp);
    return httpClient.post(
      `${Routes.general.system}/${Routes.util.registerSmartLogin}`,
      {
        registerSmartLoginModel: {
          ...params,
          totp: encryptedTotp,
        },
      }
    );
  };

  checkSystemDetails = async (params: ISystemDetailParams) =>
    httpClient.post(`${anonymous}${Routes.util.appDetails}`, {
      ...params,
      appid: `pp-${params.appid}`,
    });

  getPubliclyAvailableShifts = async (
    params: GenericPaginationModelAPIParams
  ) =>
    httpClient.post(`${Routes.general.publicWorkshift}`, {
      pagingModel: {
        ...params.pagingModel,
        itemPerPage: ITEMS_PER_PAGE,
      },
    });

  getPublicProfessionalRatingItems = async ({
    pharmacistId,
    pharmacyId,
    bookingId,
    locale,
  }: IGetPublicRatingItems & { locale?: Language }) =>
    httpClient.get(
      `${anonymous}${Routes.professional.ratingItems}/${pharmacyId}/${pharmacistId}/${bookingId}`,
      { headers: { locale: locale ?? Language.en } }
    );

  getPublicPharmacyRatingItems = async ({
    pharmacistId,
    pharmacyId,
    bookingId,
  }: IGetPublicRatingItems) =>
    httpClient.get(
      `${anonymous}${Routes.pharmacy.basePath}${Routes.professional.ratingItems}/${pharmacistId}/${pharmacyId}/${bookingId}`
    );

  publicRatePharmacy = async (params: IRatePharmacyParams) =>
    httpClient.post(`${anonymous}${Routes.professional.ratePharmacy}`, {
      model: params,
    });

  publicRateProfessional = async (params: IPharmacyRatesProfessional) =>
    httpClient.post(`${anonymous}${Routes.pharmacy.rateProfessional}`, {
      model: params,
    });

  publicRatePharmacist = async (params: IPharmacyRatesProfessional) =>
    httpClient.post(`${anonymous}${Routes.pharmacy.rate}`, params);

  deregisterSmartLogin = async (params: { totp: string; userHash: string }) => {
    const encryptedTotp = encryptPassword(params.totp);
    const encryptedHash = encryptPassword(params.userHash);

    return httpClient.post(
      `${Routes.general.system}/${Routes.util.deRegisterSmartLogin}`,
      {
        userHash: encryptedHash,
        totp: encryptedTotp,
      }
    );
  };
}

export default new UtilController();
